import React, { useState, useRef, useEffect } from 'react'
import './FieldProperties.css'

import Icon from '../Icon2'
import { iconName } from '../Icon2/constants'
import Tabs from '../Tabs/Tabs'

import Form from '../Form/Form'
import Field from '../Field/Field'
import TextInput from '../TextInput/TextInput'
import FieldLabel from '../FieldLabel/FieldLabel'
import { getTestIdFormatter } from '../../utils/helpers'


const BasicForm = (
  <Form>
    <div className="FormFields">
      <div className="FormFields__column">
        <Field>
          <FieldLabel required htmlFor="name">
            Display Name
          </FieldLabel>
          <TextInput required name="name" id="name" placeholder="Enter value" version="v2" />
        </Field>
        <Field>
          <FieldLabel required htmlFor="id">
            Unique ID
          </FieldLabel>
          <TextInput required name="id" id="id" placeholder="Enter value" version="v2" />
        </Field>
        <Field>
          <FieldLabel htmlFor="placeholder">Placeholder Value</FieldLabel>
          <TextInput
            name="placeholder"
            id="placeholder"
            placeholder="Enter value"
            version="v2"
          />
        </Field>
      </div>
      <div className="FormFields__column">
        <Field>
          <FieldLabel htmlFor="name">Instruction Value</FieldLabel>
          <TextInput
            name="instruction"
            id="instruction"
            placeholder="Enter value"
            version="v2"
          />
        </Field>
        <Field>
          <FieldLabel htmlFor="help">Help Text</FieldLabel>
          <TextInput name="help" id="help" placeholder="Enter value" version="v2" />
        </Field>
      </div>
    </div>
  </Form>
)

const AdvancedForm = (
  <Form>
    <div className="FormFields" style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div className="FormFields__column">
        <Field>
          <FieldLabel required htmlFor="name">
            Display Name
          </FieldLabel>
          <TextInput required name="name" id="name" placeholder="Enter value" version="v2"></TextInput>
        </Field>
        <Field>
          <FieldLabel htmlFor="placeholder">Placeholder Value</FieldLabel>
          <TextInput
            name="placeholder"
            id="placeholder"
            placeholder="Enter value"
            version="v2"
          ></TextInput>
        </Field>
      </div>
      <div className="FormFields__column">
        <Field>
          <FieldLabel required htmlFor="id">
            Unique ID
          </FieldLabel>
          <TextInput required name="id" id="id" placeholder="Enter value" version="v2" ></TextInput>
        </Field>
        <Field>
          <FieldLabel htmlFor="name">Instruction Value</FieldLabel>
          <TextInput
            name="instruction"
            id="instruction"
            placeholder="Enter value"
            version="v2"
          ></TextInput>
        </Field>
      </div>
    </div>
  </Form>
)

const FieldProperties = (props: any) => {
  const { basicForm, advancedForm, title = '', icon = '', isSingle, isUrl, isCTBuilder } = props
  // useEffect(() => {
  //   console.log('FieldProperties changed', props);
  // }, [props.field])

  const TabInfo = [
    {
      id: 'basic',
      title: 'Basic',
      componentData: basicForm || BasicForm,
      disabled: isCTBuilder && isUrl && isSingle ? true : false,
      testId: `cs-ct-field-${getTestIdFormatter(props?.title)}-tab-basic`
    },
    {
      id: 'advanced',
      title: 'Advanced',
      componentData: advancedForm || AdvancedForm,
      testId: `cs-ct-field-${getTestIdFormatter(props?.title)}-tab-advanced`
    },
  ]
  return (
    <div className='FieldProperties__v2'>
    <div className="FieldProperties">
      <div className="FieldProperties__header flex-v-center">
        <h4 className="FieldProperties__heading flex-v-center" data-test-id='cs-content-types-field-properties-title'>
          <Icon icon={icon} version="v2" size="medium" className="FieldProperties__heading-icon"></Icon>
          <span>{title} Properties</span>
        </h4>
      </div>
      <div className="FieldProperties__content" data-test-id="cs-field-properties-container">
        <Tabs version="v2" tabInfo={TabInfo} activeTab={isCTBuilder && isUrl && isSingle ? 'advanced' : undefined} />
      </div>
    </div>
    </div>
  )
}

export default FieldProperties
